<script setup lang="ts">
import BbelField from '@/views/builder/components/bbel/BbelField.vue'
import type { ScopeDescriptor } from '@/types/bbel-types'

// Filter when writes the service's serviceFilterExpression. True excludes the row (OutputFilter.cs:96).
defineProps<{
  modelValue: string
  scope: ScopeDescriptor
}>()

defineEmits<{
  'update:modelValue': [value: string]
}>()
</script>

<template>
  <div>
    <div class="form-label">Filter when</div>
    <BbelField
      :model-value="modelValue"
      :scope="scope"
      single-line
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <div class="form-text">A row is filtered when this is true.</div>
  </div>
</template>
